import React from "react";
import compatibilityAlert from "../../assets/compatibility_alert.svg";

interface BraveBrowserWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BraveBrowserWarningModal: React.FC<BraveBrowserWarningModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[100]">
      <div className="bg-white rounded-2xl max-w-[600px] w-full p-10 flex flex-col items-center gap-6">
        <img src={compatibilityAlert} alt="Compatibility Alert" className="h-16 w-16" />
        <div className="text-center space-y-3">
          <h2 className="text-[24px] font-medium font-ubuntu text-grey-7 leading-[38.4px]">
            Browser Compatibility Alert
          </h2>
          <div className="space-y-1 text-[14px] text-grey-6 leading-[21px] font-dm-sans">
            <p>Your current browser may limit some features used in our interviews.</p>
            <p>
              For the best experience, please use <span className="font-medium">Google Chrome</span> for full
              compatibility.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-button bg-button text-white px-4 py-2 rounded w-full uppercase text-sm"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BraveBrowserWarningModal;
